import React, { useEffect, useState } from "react";
import { UserNftDetailComp } from "components";
import { useAppDispatch, useAppSelector } from "store/store";
import { MainButton } from "components/common";
import { connectModelSlice } from "store/redux/slices/helperSlices/modelSlice";
import { useParams, useSearchParams } from "react-router-dom";
import { ContractUtility } from "utility";
import { GetFavouriteHook, switchNetwork } from "hooks";
const UserNftDetail = () => {
  const dispatch = useAppDispatch();
  const params = useParams();
  const [id, setid] = useState(null);
  const [searchParams, setSearchParams] = useSearchParams();
  const nftNetwork = searchParams.get("chain");
  const { chainId, web3 } = useAppSelector((state) => state.web3Connect);
  const { refetch: refetchFav } = GetFavouriteHook(id);

  const connectModelFn = () => {
    dispatch(connectModelSlice(true));
  };
  useEffect(() => {
    params?.id && setid({ nft_id: params?.id });
  }, [params?.id]);
  
  return (
    <div>
      {!web3 ? (
        <div className="d-flex justify-content-center mt-3">
          <MainButton connectModel onClick={connectModelFn}>
            Connect Wallet
          </MainButton>
        </div>
      ) : chainId != nftNetwork ? (
        <>
          <p>
            Your are requesting nft from{" "}
            {ContractUtility.getNetwork(nftNetwork)} but you are still connected
            to {ContractUtility.getNetwork(chainId)}. Kindly switch to{" "}
            {ContractUtility.getNetwork(nftNetwork)} to view nft.
          </p>
          <MainButton onClick={() => switchNetwork(web3, nftNetwork)}>
            {" "}
            Switch Network
          </MainButton>
        </>
      ) : (
        <UserNftDetailComp refetchFav={refetchFav} />
      )}
    </div>
  );
};

export default UserNftDetail;
